import { FormDataConsumer, useTranslate } from 'ra-core'
import React from 'react'
import { BooleanInput, Labeled } from 'react-admin'
import { productStatusChoices } from 'services/cfg/form'
import EventServiceBriefSection from 'ui-shared/FormComponents/EventServiceBriefSection'
import { isDrinkObsolete } from '../../utils'
import { EventFormDataConsumerProps } from '../GeneralTab'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import EventServiceSection from '../../EventsComponents/EventServiceSection'
import KRichTextInput from 'ui-shared/WrappedInputs/KRichTextInput'
import CustomizationInput from 'ui-shared/FormComponents/CustomizationInput'
import { TailoredEventSelectionInput } from 'ui-shared/FormComponents/TailoredEventSelectionInput'
import DrinkVariantsSelectionInput from './DrinkVariantsSelectionInput'
import useService from '../hooks/useService'
import useSelections from '../hooks/useSelections'
import KFormTab from 'ui-shared/WrappedInputs/KFormTab'
import { Badge } from '@mui/material'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'

const DrinksFormTab: React.FC = (props) => {
  const { hasSelections } = useSelections('drinks')
  const { hasCustomization } = useService('drinkService')
  const translate = useTranslate()

  return (
    <KFormTab
      {...props}
      label={
        <Badge
          badgeContent={hasSelections || hasCustomization ? 1 : 0}
          color="primary"
          variant="dot"
        >
          {translate('form.tabs.drink')}
        </Badge>
      }
    >
      <KSelectInput
        source="drinkStatus"
        label="form.fields.status"
        defaultValue={productStatusChoices[0].id}
        choices={productStatusChoices}
      />

      <KRichTextInput source="drinkNotes" label="form.fields.notes" />

      <EventServiceSection source="drinkService" />

      {/* drinks input */}
      <TailoredEventSelectionInput
        entity="drinks"
        label="form.fields.drinks"
        source="drinks"
        getIsProductObsolete={isDrinkObsolete}
        hideQuantity
      >
        <DrinkVariantsSelectionInput />
      </TailoredEventSelectionInput>

      {
        <FormDataConsumer>
          {({ formData }: EventFormDataConsumerProps) => {
            const service = formData.productServices?.drinkService

            return (
              <React.Fragment>
                <CustomizationInput
                  source="productServices.drinkService.customization"
                  customization={service?.customization}
                />
                {service?.briefQuestions && service?.briefQuestions.length ? (
                  <React.Fragment>
                    <Kdivider title="Event Brief" headingLevel="h3" />
                    <Labeled label="form.fields.briefConfirmation">
                      <BooleanInput
                        source={`productServices.drinkService.briefConfirmed`}
                        label={service?.briefConfirmed ? 'Yes' : 'No'}
                        disabled
                      />
                    </Labeled>
                    <EventServiceBriefSection serviceSource="productServices.drinkService" />
                  </React.Fragment>
                ) : null}
              </React.Fragment>
            )
          }}
        </FormDataConsumer>
      }
    </KFormTab>
  )
}

export default DrinksFormTab
